import { createDraftSafeSelector } from "@reduxjs/toolkit";

import { RootState } from "../../../store-types";
import { IEmployeesState } from "../shared";

import { EMPLOYEES_MODULE_NAME } from "./constants";

export const getEmployeesState = (rootState: RootState): IEmployeesState =>
  rootState[EMPLOYEES_MODULE_NAME];

export const getSelectedIds = createDraftSafeSelector(
  getEmployeesState,
  (state: IEmployeesState) => state.selectedIds
);
export const getSearchText = createDraftSafeSelector(
  getEmployeesState,
  (state: IEmployeesState) => state.searchText
);
